export const MAIN_CLASS_NAME = 'project-source-title';
